/*
 *
 * Config for API
 *
 */

const BASE_URL = '/';

const API_ENDPOINTS = {
  AUTH: {
    UPDATE_PASSWORD: `${BASE_URL}api/v1/user/update_password`,
    LOGOUT: `${BASE_URL}api/v1/user/logout`,
    CURRENT_USER: `${BASE_URL}api/v1/user/current_user`,
  },
};

export default API_ENDPOINTS;
